import UserStoreModule from '../../../user/store/module';

export default function isPosReady(): boolean {
  return !!UserStoreModule.data?.store.is_pos_ready;
}
